<script lang="ts">
	import Text from '$lib/components/ui/text/text.svelte';
	import Icon from '@iconify/svelte';
	import Header from './header/Header.svelte';
	import { t } from '$lib/i18n';

	const links = [
		{ link: '', icon: 'ri:twitter-x-fill' },
		{ link: '', icon: 'lets-icons:insta' },
		{ link: '', icon: 'file-icons:telegram' },
		{ link: '', icon: 'ic:baseline-discord' }
	];
</script>

<div class="relative mx-auto flex w-full flex-col items-center md:gap-10">
	<div class="star-background w-full">
		<div class="stars stars-1"></div>
		<div class="stars stars-2"></div>
		<div class="stars stars-3"></div>
	</div>

	<Header title={$t('landing.join_the_community')}></Header>

	<div class="relative flex flex-col items-center">
		<div class="pink-eclipse w-[350px] blur-[150px] md:w-[550px]"></div>
		<div>
			<img src="/img/landing/community/mascot.png" alt="mascot" class="h-[300px] md:h-full" />
		</div>
		<!-- desktop view -->
		<div class="hidden justify-center gap-10 lg:flex">
			<a
				href="https://x.com/ChainPartyXYZ"
				target="_blank"
				class="pink-circle absolute left-0 top-[20%] flex translate-x-[-150px] items-center justify-center rounded-full text-white transition delay-150 duration-300 ease-in-out hover:scale-105"
			>
				<Icon icon="ri:twitter-x-fill" width="2.5em" height="2.5em" />
			</a>
			<a
				href="https://www.instagram.com/chainpartyxyz/"
				target="_blank"
				class="pink-circle absolute right-0 top-[30%] flex translate-x-[150px] items-center justify-center rounded-full text-white transition delay-150 duration-300 ease-in-out hover:scale-105"
			>
				<Icon icon="lets-icons:insta" width="3em" height="3em" />
			</a>
			<a
				href="https://t.me/ChainPartyXYZ"
				target="_blank"
				class="pink-circle absolute bottom-[30%] left-20 flex translate-x-[-150px] items-center justify-center rounded-full text-white transition delay-150 duration-300 ease-in-out hover:scale-105"
			>
				<Icon icon="file-icons:telegram" width="2.5em" height="2.5em" />
			</a>
			<a
				href="https://linktr.ee/ChainPartyXYZ"
				target="_blank"
				class="pink-circle absolute bottom-[20%] right-20 flex translate-x-[150px] items-center justify-center rounded-full text-white transition delay-150 duration-300 ease-in-out hover:scale-105"
			>
				<Icon icon="simple-icons:linktree" width="3em" height="3em" />
			</a>
		</div>
		<!-- mobile view -->
		<div class="my-5 flex justify-center gap-3 lg:hidden">
			<a
				href="https://x.com/ChainPartyXYZ"
				target="_blank"
				class=" pink-circle flex items-center justify-center rounded-full text-white transition delay-150 duration-300 ease-in-out hover:scale-105"
			>
				<Icon icon="ri:twitter-x-fill" width="2em" height="2em" />
			</a>
			<a
				href="https://www.instagram.com/chainpartyxyz/"
				target="_blank"
				class=" pink-circle flex items-center justify-center rounded-full text-white transition delay-150 duration-300 ease-in-out hover:scale-105"
			>
				<Icon icon="lets-icons:insta" width="2.5em" height="2.5em" />
			</a>
			<a
				href="https://t.me/ChainPartyXYZ"
				target="_blank"
				class=" pink-circle flex items-center justify-center rounded-full text-white transition delay-150 duration-300 ease-in-out hover:scale-105"
			>
				<Icon icon="file-icons:telegram" width="2em" height="2em" />
			</a>
			<a
				href="https://linktr.ee/ChainPartyXYZ"
				target="_blank"
				class=" pink-circle flex items-center justify-center rounded-full text-white transition delay-150 duration-300 ease-in-out hover:scale-105"
			>
				<Icon icon="simple-icons:linktree" width="2.5em" height="2.5em" />
			</a>
		</div>

		<Text size="3xl" class="pixel-font px-1 text-center md:translate-y-[-20px]"
			>5500+ {$t('landing.registered_user')}</Text
		>
	</div>
</div>

<style>
	.pink-circle {
		width: 94px;
		height: 94px;
		border-radius: 50%;
		box-shadow: 0px -8px 4px 0px #00000040 inset;
		background: linear-gradient(180deg, #ec05f8 0%, #9723de 100%);
		z-index: 10;
	}

	@media (max-width: 768px) {
		.pink-circle {
			width: 70px;
			height: 70px;
		}
	}

	.pink-eclipse {
		position: absolute;
		height: auto;
		aspect-ratio: 1;
		border-radius: 50%;
		opacity: 0.5;
		transform: translateZ(0);
		background-color: #833ac1;
		z-index: -1;
	}

	.star-background {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: -1;
		background: #110f27;
		overflow: hidden;
	}

	.stars {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-image: radial-gradient(white, rgba(255, 255, 255, 0.2) 2px, transparent 2px),
			radial-gradient(white, rgba(255, 255, 255, 0.15) 1px, transparent 1px),
			radial-gradient(white, rgba(255, 255, 255, 0.1) 2px, transparent 2px),
			radial-gradient(rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.1) 2px, transparent 2px);
		background-size:
			550px 550px,
			350px 350px,
			250px 250px,
			150px 150px;
		background-position:
			0 0,
			40px 60px,
			130px 270px,
			70px 100px;
		opacity: 0.3;
	}

	.stars-1 {
		animation:
			twinkle 10s linear infinite,
			move-1 200s linear infinite;
	}

	.stars-2 {
		animation:
			twinkle 15s linear infinite,
			move-2 250s linear infinite;
	}

	.stars-3 {
		animation:
			twinkle 20s linear infinite,
			move-3 300s linear infinite;
	}

	@keyframes twinkle {
		0%,
		100% {
			opacity: 0.3;
		}
		50% {
			opacity: 0.8;
		}
	}

	@keyframes move-1 {
		0% {
			transform: rotate(0deg) scale(1);
		}
		50% {
			transform: rotate(180deg) scale(1.1);
		}
		100% {
			transform: rotate(360deg) scale(1);
		}
	}

	@keyframes move-2 {
		0% {
			transform: rotate(0deg) scale(1.2);
		}
		50% {
			transform: rotate(-180deg) scale(0.8);
		}
		100% {
			transform: rotate(-360deg) scale(1.2);
		}
	}

	@keyframes move-3 {
		0% {
			transform: rotate(0deg) scale(0.8);
		}
		50% {
			transform: rotate(180deg) scale(1.2);
		}
		100% {
			transform: rotate(360deg) scale(0.8);
		}
	}
</style>
